export const ROLES = {
  ADMIN: "admin",
  SUPERADMIN: "superAdmin",
};
